"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sections = void 0;
var react_1 = __importDefault(require("react"));
var __1 = require("..");
function sections(page, ctaClicked) {
    var _a;
    return (_a = page.sections) === null || _a === void 0 ? void 0 : _a.map(function (section, index) {
        switch (section.type) {
            case 'ctaButton':
                return react_1.default.createElement(__1.CTAButton, __assign({ key: index }, section.data, { onClick: ctaClicked }));
            case 'seoHeader':
                // Only add seoHeader if it wasnt already defined in the page itself
                // This helps so old pages dont break when upgrading
                return !(page === null || page === void 0 ? void 0 : page.seoHeaderConfig) ? (react_1.default.createElement(__1.SEOHeader, __assign({ key: index }, section.data))) : null;
            case 'heroHeader':
                return react_1.default.createElement(__1.HeroHeader, __assign({ key: index }, section.data, { onClick: ctaClicked }));
            case 'shortHeroHeader':
                return (react_1.default.createElement(__1.ShortHeroHeader, __assign({ key: index }, section.data, { onClick: ctaClicked })));
            case 'processBox':
                return react_1.default.createElement(__1.ProcessBox, __assign({ key: index }, section.data));
            case 'processCard':
                return react_1.default.createElement(__1.ProcessCard, __assign({ key: index }, section.data));
            case 'kontakt':
                return react_1.default.createElement(__1.Kontakt, __assign({ key: index }, section.data, { onClick: ctaClicked }));
            case 'oldwayNewway':
                return react_1.default.createElement(__1.OldwayNewway, __assign({ key: index }, section.data));
            default:
                return (react_1.default.createElement(section.component, __assign({ key: index }, section.data, { ctaClicked: ctaClicked })));
        }
    });
}
exports.sections = sections;
//# sourceMappingURL=sections.js.map